<template>
  <div>
    <v-row>
      <v-col cols="12" md="5" lg="5">
        <h3 class="mb-2"></h3>Scholars Result di quiz</h3>
      </v-col>
      <v-col cols="12" md="2" lg="2">
        <v-btn
          class="text-capitalize"
          @click="exportData"
          height="38px"
          color="white"
        >
          <v-icon color="green">mdi-microsoft-excel</v-icon>
          Export Data
        </v-btn>
      </v-col>
      <v-col cols="12" md="5" lg="5">
        <v-text-field
          placeholder="Search User"
          solo
          v-model="find"
          @keyup="fetchData"
          hide-details
          dense
          background-color="#f6f6f6"
          :color="color"
          prepend-inner-icon="mdi-magnify"
          flat
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="mt-3" v-if="dataSet" style="min-height: 300px">
      <div v-if="dataSet.length && !loading">
        <v-card
          class="rounded_max d-flex mb-3"
          v-for="(item, i) in dataSet"
          :key="`sect_${i}`"
          elevation="1"
          style="overflow: hidden"
        >
          <div
            class="strip-y"
            :style="`background: ${color ? color : '#f0ac91'}`"
          ></div>
          <v-row no-gutters>
            <v-col cols="9" md="9" lg="9">
              <div class="py-3 px-2 d-flex">
                <router-link
                  class="opener_name"
                  :to="`/scholar/${item.user_id}`"
                >
                  <v-avatar size="35" class="mr-2">
                    <img
                      :src="item.profile_picture ? item.profile_picture : ava"
                      class="obj_fit"
                      alt="isyan"
                    />
                  </v-avatar>
                </router-link>
                <div>
                  <router-link
                    class="opener_name"
                    :to="`/scholar/${item.user_id}`"
                  >
                    <h3 v-snip="2" class="name_q black--text">
                      {{ item.name }}
                    </h3>
                  </router-link>
                  <p class="default_txt">{{ item.no_tf }}</p>
                </div>
              </div>
            </v-col>
            <v-col cols="3" md="3" lg="3">
              <div class="py-3 px-2 total_question" style="height: 100%">
                <div class="d-flex align-end">
                  <h3 class="success--text">{{ item.result }}</h3>
                  <p class="default_txt mr-1">/{{ item.total_question }}</p>
                </div>
                <div>
                  <p class="default_txt">questions</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div
        class="empty d-flex align-center justify-center flex-column"
        v-if="!dataSet.length"
      >
        <img
          src="../../../../assets/img/redaksi/pagenotfound.png"
          height="150px"
          alt=""
        />
        <b class="default_txt my-3">Data not found</b>
      </div>
    </div>
    <div v-if="loading">
      <v-card class="mb-3 pa-3 rounded-lg" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      </v-card>
    </div>
    <div class="text-center pa-3" v-if="dataSet">
      <v-pagination
        v-model="page"
        :color="color"
        @input="fetchData"
        :length="last_page"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "resultQuiz",
  props: ["color"],
  data() {
    return {
      dataSet: null,
      loading: false,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
    };
  },
  computed: {
    ...mapState({
      ava: (state) => state.ava,
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    exportData() {
      let body = {
        instance_id: this.$route.params.idInstance,
      };
      let data = {
        path: `manage/quiz/export`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          location.href = data.data.path;
        })
        .catch((e) => {
          this.$toast.error(e.message);
        });
    },
    fetchData() {
      let instance = this.$route.params.idInstance;
      this.loading = true;

      let data = {
        path: `manage/quiz/${instance}?filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          if (data.data.length) {
            this.dataSet = data.data;
            this.total = data.total;
            this.last_page = data.last_page;
            this.$emit("empty", false);
          } else {
            this.$emit("empty", true);
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.strip-y {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
.total_question {
  display: flex;
  align-items: flex-end;
}
@media (max-width: 576px) {
  .name_q {
    font-size: 15px;
  }
  .total_question {
    display: block;
  }
}
</style>
